import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7dd63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请修改LPOA初始密码后再试", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.dialogVisible,
    title: "温馨提示",
    width: "500px",
    "destroy-on-close": "",
    center: "",
    onClose: _ctx.close
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "footer-confirm",
        onClick: _ctx.confirm,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("去修改")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["model-value", "onClose"]))
}